<template>
  <el-dialog title="确认受理" :visible.sync="showDialog" append-to-body width="50%">
    <div>确认受理</div>
    <div class="btns">
      <el-button size="small" type="primary" @click="confirmAcceptance">审批通过</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    currCaseId: {
      required: true
    }
  },
  data() {
    return {
      showDialog: false
    }
  },
  mounted() {

  },
  methods: {
    open() {
      this.showDialog = true;
    },
    close() {
      this.showDialog = false;
    },
    confirmAcceptance() {
      console.log(this.currCaseId);
      this.close();
    }
  }
}
</script>
<style lang="less" scoped>
@import '../../../../style/mixin';
.btns{
  .flex(flex-end);
  // margin-top: 20px;
  // .el-button--small:nth-child(2){
  //   margin-left: 30px;
}
</style>